<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-data-table
            class="pa-2"
            :headers="headers"
            :items="packaging"
            item-key="keyValue"
            :items-per-page="itemsPerPage"
            hide-default-footer
            fixed-header
            must-sort
            sort-by="name"
            dense
            :loading="loading"
            loading-text="Loading all data....please wait"
            :search="search"
            ><template v-slot:top>
              <v-toolbar height="80" flat>
                <v-toolbar-title
                  >Packaging ({{ packaging.length }})</v-toolbar-title
                >

                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="loading"
                  icon
                  color="primary"
                  @click="refresh()"
                  ><v-icon>mdi-refresh</v-icon></v-btn
                >
                <v-btn
                  :disabled="loading"
                  fab
                  small
                  color="primary"
                  @click="NewItem()"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >
              </v-toolbar>
            </template>
            <template v-slot:item.name="{ item }">
              <div class="primary--text row-pointer" @click="EditItem(item)">
                {{ item.name }}
              </div>
            </template>
            <template v-slot:item.units="{ item }">
              <span>{{ formatNumber(item.units, 2) }}</span>
            </template>
            <template v-slot:item.price="{ item }">
              <span>{{ formatCurrency(item.price, 2) }}</span>
            </template>
            <template v-slot:item.unitPrice="{ item }">
              <span>{{ formatCurrency(item.unitPrice, 2) }}</span>
            </template>
            <template v-slot:item.used="{ item }">
              <span>{{ UsedInRecipes(item.keyValue).length }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                class="mr-2"
                color="primary"
                small
                :disabled="UsedInRecipes(item.keyValue).length > 0"
                @click="DeleteItem(item)"
              >
                mdi-delete-outline
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="body-1"
          >Delete "{{ editedItem.name }}" ?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            :disabled="saving"
            @click="DeleteConfirm()"
            >Yes</v-btn
          >
          <v-btn
            small
            color="primary"
            :disabled="saving"
            @click="deleteDialog = false"
            >No</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDialog" persistent max-width="600">
      <PackagingType
        :editedItem="editedItem"
        :editedIndex="editedIndex"
        @Save="showDialog = false"
        @Cancel="showDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import utilities from "@/services/Utilities.js";
import { mapState } from "vuex";
import PackagingType from "../components/PackagingType.vue";
export default {
  name: "Packaging",
  components: {
    PackagingType
  },
  computed: {
    ...mapState(["packaging", "loading", "saving"])
  },
  data() {
    return {
      search: "",
      itemsPerPage: -1,
      headers: [
        { text: "Name", value: "name" },
        { text: "Units", value: "units", align: "end" },
        { text: "Price", value: "price", align: "end" },
        { text: "Unit price", value: "unitPrice", align: "end" },
        {
          text: "Used in recipes",
          value: "used",
          align: "end",
          sortable: false
        },
        { text: "Actions", value: "actions", sortable: false }
      ],
      editedItem: {},
      editedIndex: -1,
      showDialog: false,
      deleteDialog: false
    };
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("LoadData", true);
    },
    UsedInRecipes(keyValue) {
      return this.$store.getters.UsedInRecipes(keyValue);
    },
    EditItem: function(item) {
      this.editedIndex = this.packaging.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.showDialog = true;
    },
    NewItem: function() {
      let item = {
        itemType: "packaging",
        keyValue: "TempKeyPackaging",
        name: "",
        units: 0.0,
        price: 0.0,
        unitPrice: 0.0
      };
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editedIndex = -1;
      this.showDialog = true;
    },
    DeleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
    },
    async DeleteConfirm() {
      this.editedIndex = await this.$store.dispatch(
        "DeletePackagingType",
        this.editedItem
      );
      this.deleteDialog = false;
    },
    formatNumber(value, fractionDigits = 2) {
      return utilities.formatNumber(value, fractionDigits);
    },
    formatCurrency(value, fractionDigits = 2) {
      return utilities.formatCurrency(value, fractionDigits);
    }
  }
};
</script>
<style lang="css" scoped>
.row-pointer {
  cursor: pointer;
}
</style>
